var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M37 23a3 3 0 100 5.999A3 3 0 0037 23zM0 28h30v-4H0v4zM0 0v4h40V0H0zm0 16h40v-4H0v4z"}));
}

Menu.defaultProps = {"viewBox":"0 0 40 29","fill":"currentColor"};

module.exports = Menu;

Menu.default = Menu;
